import { supabase } from "@/integrations/supabase/client";
import { useUserSession } from "./use-user-session";

/**
 * Returns the project_id for the current user.
 * Backed by the shared `useUserSession` query — no extra round-trip.
 */
export function useProjectId() {
  const session = useUserSession();
  return {
    ...session,
    data: session.data?.projectId ?? null,
  } as ReturnType<typeof useUserSession> & { data: string | null };
}

/**
 * Utility to get project_id from supabase directly (for non-hook contexts).
 */
export async function fetchProjectId(): Promise<string> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error("Not authenticated");

  const { data, error } = await supabase
    .from("profiles")
    .select("project_id")
    .eq("id", user.id)
    .single();

  if (error || !data?.project_id) throw new Error("Could not determine project");
  return data.project_id;
}
